import { observer, inject } from "mobx-react";
import { Outlet } from "react-router-dom";
import DateRangePicker from "../UI/DateRangePicker";
import { Text } from "../UI";
import { SearchInput } from "../UI/Input";

// `search` and `date` are the filters currently applied by the page, so the controls always show them
const SearchHeader = ({ title, search, date, handleDateChange, handleSearchChange }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-start",
          gap: "0.5em",
          alignItems: "center",
        }}>
        <Text.H1 style={{ textAlign: "start" }} color="#4A69A6">
          {title}
        </Text.H1>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}>
          <SearchInput value={search} handleSearchChange={handleSearchChange} />
          <DateRangePicker value={date} handleDateChange={handleDateChange}></DateRangePicker>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default inject()(observer(SearchHeader));
